module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.items.length) ? _c('transition-group', {
    staticClass: "timeline",
    attrs: {
      "name": "insertion-top",
      "tag": "ol"
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('li', {
      key: item.id,
      staticClass: "timeline__item",
      class: {
        'is-active': _vm.isActive(item), 'is-marked': _vm.isMarked(item)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.open(item)
        }
      }
    }, [_vm._t("item", [_vm._v(_vm._s(item))], null, item)], 2)
  })) : _c('p', {
    staticClass: "sidebar__empty small"
  }, [_vm._t("empty", [_vm._v("Geen " + _vm._s(_vm.collectionName) + " gevonden")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f48e585","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/admin/components/sidebar/Timeline.vue
// module id = Yadj
// module chunks = 0 1